/**
 * Legacy hash redirector.
 *
 * The pre-Phase-8C Settings page used in-page accordions identified by
 * URL hash (`/settings#profile`, `/settings#admin`, etc.).  Every help
 * doc, screenshot, and user muscle-memory still uses those hashes —
 * rewrite them to the new per-pillar URLs so nothing breaks.
 *
 * Mounted inside SettingsIndex so it only runs when the user actually
 * lands on `/settings`.  Picks up the hash, finds the mapping, and
 * navigates to the new sub-page with `replace: true` so the user's
 * back-button stays clean.
 */
import { useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";

const HASH_MAP = {
  // Old accordion IDs → new sub-page route (relative to /settings/)
  profile:      "profile",
  workflow:     "profile",   // workflow knobs live in Profile now
  integrations: "platform",
  admin:        "team",
  data:         "platform",
  diagnostics:  "platform",
};

export default function LegacyHashRedirect() {
  const nav = useNavigate();
  const loc = useLocation();

  useEffect(() => {
    if (!loc.hash) return;
    const key = loc.hash.replace(/^#/, "").toLowerCase();
    const dest = HASH_MAP[key];
    if (dest) {
      nav(`/settings/${dest}`, { replace: true });
    }
  }, [loc.hash, nav]);

  return null;
}

// Exposed for the regression test so future agents can verify the
// mapping hasn't drifted.
export { HASH_MAP };
